export const searchModalElements = {
	placeholder: 'Site search',
	analyticsId: 'global-search-input',
	ariaLabelledBy: 'Search MLC Advisor Secure',
	autoSuggestId: 'global-search-input',
};
